import {
  Container,
  Flex,
  Box,
  Image,
  Spacer,
  Text,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import React from "react";

import { Link } from "react-router-dom";
import Footer from "../Components/Footer";

function Content() {
  return (
    <div style={{ textAlign: "left" }}>
      <Container
        minW="full"
        h="auto"
        style={{
          backgroundColor: "#26a9e1",
          display: "flex",
          justifyContent: "space-between",
          padding: "0px",
        }}
      >
        <Box paddingTop="90px" paddingLeft="10%" width="45%">
          <Text
            style={{ fontFamily: "sans-serif" }}
            color="white"
            as="b"
            fontSize="4xl"
          >
            Online personal trainer
          </Text>
          <Text marginTop={8} fontSize="22px">
            Gymwolf has certified personal trainers that provide you with
            customised workout plans depending on your goals. Our trainers track
            your progress, coach and motivate you daily through our web and
            smartphone app.
          </Text>
          <Button
            style={{
              padding: "28px 100px 28px 100px",
              fontSize: "20px",
              color: "white",
              backgroundColor: "black",
            }}
            mt={8}
            variant="solid"
          >
            Learn More
          </Button>
        </Box>
        <Box>
          <img
            style={{ width: "100%", height: "100%" }}
            src="https://www.gymwolf.com/img/trainer-bg.jpg"
            alt="img"
          />
        </Box>
      </Container>

      <Container
        minW="full"
        h="auto"
        style={{
          display: "flex",
          gap: "20%",
          padding: "0px",
          paddingTop: "5%",
          paddingLeft: "10%",
          paddingRight: "5%",
        }}
      >
        <Box width="45%">
          <Text style={{ fontFamily: "sans-serif" }} as="b" fontSize="4xl">
            Features
          </Text>
          <Text marginTop={8} fontSize="22px">
            Gymwolf is a workout tracking tool. Add workouts, create your own
            customized workout plans or find suitable plan from other users.
            Accomplish your goals with motivation from personal trainer and
            committed training.
          </Text>
          <Button
            style={{
              padding: "28px 100px 28px 100px",
              fontSize: "20px",
              color: "white",
              backgroundColor: "#26a9e1",
            }}
            mt={8}
          >
            Take a Tour
          </Button>
        </Box>
        <Box>
          <img
            style={{ width: "100%", marginTop: "15%" }}
            src="https://www.gymwolf.com/img/landing/features-img.png"
            alt="img"
          />
        </Box>
      </Container>

      <Container
        minW="full"
        h="auto"
        style={{
          display: "flex",
          gap: "25%",
          padding: "0px",
          paddingTop: "5%",
          paddingLeft: "12%",
          paddingRight: "5%",
        }}
      >
        <Box>
          <img
            style={{ width: "100%", marginTop: "15%" }}
            src="https://www.gymwolf.com/img/landing/progress-img.png"
            alt="img"
          />
        </Box>

        <Box width="45%">
          <Text style={{ fontFamily: "sans-serif" }} as="b" fontSize="4xl">
            See your progress
          </Text>
          <Text marginTop={8} fontSize="22px">
            Gymwolf provides different graphs that help you track your progress.
            There are graphs for gym workouts, cardio workouts and bodyweight.
            The graphs are highly customizable: you can select the date range,
            exercise and group the results by month, week or single workout.
          </Text>
          <Button
            style={{
              padding: "28px 100px 28px 100px",
              fontSize: "20px",
              color: "white",
              backgroundColor: "#26a9e1",
            }}
            mt={8}
          >
            Take a Tour
          </Button>
        </Box>
      </Container>

      <Container
        minW="full"
        h="auto"
        style={{
          display: "flex",
          gap: "20%",
          padding: "0px",
          paddingTop: "5%",
          marginBottom: "5%",
          paddingLeft: "10%",
          paddingRight: "5%",
        }}
      >
        <Box width="45%">
          <Text style={{ fontFamily: "sans-serif" }} as="b" fontSize="4xl">
            Database with 300+ exercises
          </Text>
          <Text marginTop={8} fontSize="22px">
            Gymwolf has a database with over 300 exercises. The exercises come
            with detailed descriptions, tips and step-by-step images. If you
            don't find a exercise from our database, then you can also add your
            own exercises.
          </Text>
          <Button
            style={{
              padding: "28px 100px 28px 100px",
              fontSize: "20px",
              color: "white",
              backgroundColor: "#26a9e1",
            }}
            mt={8}
          >
            Check out
          </Button>
        </Box>
        <Box>
          <img
            style={{ width: "100%", marginTop: "15%" }}
            src="https://www.gymwolf.com/img/landing/database-img.png"
            alt="img"
          />
        </Box>
      </Container>

      <Container maxW="full" backgroundColor="#e6e7ea">
        <Box id="box">
          <span>1</span>
          <span>1</span>
          <span>4</span>
          <span>9</span>
          <span>2</span>
          <span>6</span>
          <span>9</span>
          <span>6</span>
          <span>5</span>
          <span>0</span>
          <p>Kg</p>
        </Box>
        <Box>
          <Text
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "5px",
              fontSize: "18px",
              paddingBottom: "7%",
            }}
          >
            LIFTED USING GYMWOLF
          </Text>
        </Box>
      </Container>

      {/* Footer HTML Js and CSS */}

      <Footer/>
    </div>
  );
}
export default Content;
